import D1 from "../../components/ExcerciseTypes/Design/TypeIn";
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';
import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: { // Exercise num
    unit: 'Unit 8',
    id: 'SB3-U8-P57-E1',
    audio: 'img/FriendsPlus/Page57/Audio/audio-e1-p57.mp3',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page57/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page57/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page57/Audio/tieude-e1-p57.mp3' },
        { url: 'img/FriendsPlus/Page57/E1/3.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page57/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page57/E1/5.jpg', audioUrl: 'img/FriendsPlus/Page57/Audio/hinh1-e1-p57.mp3' },
        { url: 'img/FriendsPlus/Page57/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page57/E1/7.jpg', audioUrl: 'img/FriendsPlus/Page57/Audio/hinh2-e1-p57.mp3' },
        { url: 'img/FriendsPlus/Page57/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page57/E1/9.jpg', audioUrl: 'img/FriendsPlus/Page57/Audio/hinh3-e1-p57.mp3' },
        { url: 'img/FriendsPlus/Page57/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page57/E1/11.jpg', audioUrl: 'img/FriendsPlus/Page57/Audio/hinh4-e1-p57.mp3' },
        { url: 'img/FriendsPlus/Page57/E1/12.jpg' },
      ],
      [{ url: 'img/FriendsPlus/Page57/E1/13.jpg' }],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 8',
    id: 'SB3-U8-P57-E2',
    audio: 'img/FriendsPlus/Page57/Audio/audio-e2-p57.mp3',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page57/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page57/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page57/Audio/tieude-e2-p57.mp3' },
        { url: 'img/FriendsPlus/Page57/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page57/E2/4.jpg' },
      ],
    ],
  },
  3: { // Exercise num
    // Exercise num
    unit: 'Unit 8',
    id: 'SB3-U8-P57-E3',
    audio: '',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page57/E3/Key/answerKey.png',
    titleQuestion: [{ num: '3', title: 'Read the chant again. Circle the sound i_e.', color: "#1F4199" }],
    question: {
      Write: {
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        // initialWordStyle: { margin: '5px 0', border: 'solid 2px', borderColor: 'black', borderRadius: '50%', padding: '0 5px' },
        initialWordStyle: { margin: '5px 0', border: 'none', borderColor: 'transparent', borderRadius: '50%' },
        selectWordStyle: { border: 'solid 2px', borderColor: '#00a8ec', padding: '0 5px' },
        listWords: [
          'y|our b|ike. F|ly y|our k|ite.',//0
          'The b|ike is red. The k|ite is wh|ite.',//1
          'Wh|ite k|ite, wh|ite k|ite.',//2
          'Co|unt the child|ren in the l|ine.',//3
          'All toget|her th|ere are n|ine.',//4
          'N|ine in the l|ine. N|ine in the l|ine.',//5
        ],
        answers: ['0-6', '0-18', '1-4', '1-14', '1-20', '2-2', '2-6', '2-10', '2-14', '3-16', '4-14', '5-2', '5-10', '5-14', '5-22'],
        initialValue: [],
      },
      Layout: `
        <div style='display: flex; flex-direction: row;position: relative;align-items: center;background-color: #fde9bc; padding: 20px;'>
          <div style='width: 50%; margin-left: 20px; color: #ec870e;text-align: center;'>
            <div>R<span style="border: 2px solid rgb(0, 168, 236); border-radius: 50%; padding: 0px 5px;">ide</span> <input id='0' type='Circle' /></div>
            <div><input id='1' type='Circle' /></div>
            <div><input id='2' type='Circle' /></div>
            <div><input id='3' type='Circle' /></div>
            <div><input id='4' type='Circle' /></div>
            <div><input id='5' type='Circle' /></div>
          </div>
          <div style='width: '50%'>
            <img src="img/FriendsPlus/Page57/E3/title.jpg" style="width: 100%">
          </div>
        </div>
      `,
    },
  },
  4: { // Exercise num
    unit: 'Unit 8',
    id: 'SB3-U8-P57-E4',
    audio: 'img/FriendsPlus/Page57/Audio/audio-e4-p57.mp3',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page57/E4/Key/answerKey.png',
    isAllowSubmit: false,
    maxLength: 2,
    textAlign: 'center',
    padding: 0,
    question: [],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page57/E4/1.jpg' },
        { url: 'img/FriendsPlus/Page57/E4/2.jpg', audioUrl: 'img/FriendsPlus/Page57/Audio/tieude-e4-p57.mp3' },
        { url: 'img/FriendsPlus/Page57/E4/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page57/E4/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page57/E4/5.jpg' },
        { url: 'img/FriendsPlus/Page57/E4/6.jpg', input: true, answer: "b" },
        { url: 'img/FriendsPlus/Page57/E4/7.jpg' },
        { url: 'img/FriendsPlus/Page57/E4/8.jpg', input: true, answer: "k" },
        { url: 'img/FriendsPlus/Page57/E4/9.jpg' },
        { url: 'img/FriendsPlus/Page57/E4/10.jpg', input: true, answer: "wh" },
        { url: 'img/FriendsPlus/Page57/E4/11.jpg' },
        { url: 'img/FriendsPlus/Page57/E4/12.jpg', input: true, answer: "t" },
        { url: 'img/FriendsPlus/Page57/E4/13.jpg' },
        { url: 'img/FriendsPlus/Page57/E4/14.jpg', input: true, answer: "k" },
        { url: 'img/FriendsPlus/Page57/E4/15.jpg' },
        { url: 'img/FriendsPlus/Page57/E4/16.jpg', input: true, answer: "t" },
        { url: 'img/FriendsPlus/Page57/E4/17.jpg' },
      ],
    ]
  },
  5: { // Exercise num
    unit: 'Unit 8',
    id: 'SB3-U8-P57-E5',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: 'img/FriendsPlus/Page57/E5/1.jpg' }]],
  },
}

export default json;